<h2 mat-dialog-title>Record changed</h2>
<mat-dialog-content>
  <p>{{ data.message || 'This record was changed by someone else — reload and re-apply your changes.' }}</p>
</mat-dialog-content>
<mat-dialog-actions align="end">
  <button mat-flat-button color="primary" (click)="onReload()">Reload</button>
</mat-dialog-actions>
